import { SvgIcon } from '../../../mui/SvgIcon';
import { UxSvgIconProps } from '../ux/types';

export function BpCloudUpload(props: UxSvgIconProps) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 16 16'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.71,7.29C8.53,7.11,8.28,7,8,7S7.47,7.11,7.29,7.29l-3,3
			C4.11,10.47,4,10.72,4,11c0,0.55,0.45,1,1,1c0.28,0,0.53-0.11,0.71-0.29L7,10.41V15c0,0.55,0.45,1,1,1s1-0.45,1-1v-4.59l1.29,1.29
			C10.47,11.89,10.72,12,11,12c0.55,0,1-0.45,1-1c0-0.28-0.11-0.53-0.29-0.71L8.71,7.29z M12,4c-0.03,0-0.07,0-0.1,0.01
			C11.44,1.72,9.42,0,7,0C4.24,0,2,2.24,2,5c0,0.11,0.01,0.22,0.02,0.33C0.83,5.89,0,7.1,0,8.5c0,1.43,0.86,2.66,2.09,3.2
			C2.04,11.47,2,11.24,2,11c0-0.83,0.34-1.58,0.88-2.12l3-3C6.42,5.34,7.17,5,8,5s1.58,0.34,2.12,0.88l3,3
			C13.66,9.42,14,10.17,14,11c0,0.16-0.02,0.32-0.05,0.47C15.17,10.78,16,9.5,16,8C16,5.79,14.21,4,12,4z'
      />
    </SvgIcon>
  );
}
